import { createAction } from '@ngrx/store';
import { SiteControllerInternalModel } from '@spog-ui/shared/models/site-controllers';

export const loadAction = createAction(
  '[Site Controllers / State] Load',
  (siteControllers: SiteControllerInternalModel[]) => ({ siteControllers }),
);
